import React, { useContext, useCallback } from 'react';
import { Context } from './ModalContext';

export const useModal = (modal: React.ReactNode) => {
  const { onPresent, onDismiss } = useContext(Context);
  const onPresentCallback = useCallback(() => {
    onPresent(modal);
  }, [modal, onPresent]);

  return [onPresentCallback, onDismiss];
};

export default useModal;
